export const getReportStatus = (report) => {
  const disabledStatuses = ['pending', 'in_progress', 'failed', 'big_report_error'];
  const queued = report.state === 'pending' && Boolean(report.queue_position);

  return {
    pending: report.state === 'pending' || report.state === 'in_progress',
    inProgress: report.state === 'in_progress',
    queued,
    queuePosition: queued ? report.queue_position : null,
    progress: report.progress,
    failed: report.state === 'failed',
    bigReportError: report.state === 'big_report_error',
    disabled: disabledStatuses.includes(report.state),
  };
};

export const redirectToCustomReports = (path = '') => {
  const redirectURL = new URL(`/custom_exports${path}`, window.location.origin);
  window.location.assign(redirectURL.href);
};
